import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapGetters } from "vuex";
import CoinDialog from "./dialog/coin-dialog.vue";
import CoinsApiService from "@/core/services/api.service.coins";
import ConfirmDialog from "@/view/pages/ConfirmDialog";

export default {
  components: { CoinDialog, ConfirmDialog },
  data() {
    return {
      isInitialized: false,
      dataSource: [],
      filteredData: [],
      searchQuery: "",
      loading: false
    };
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.name }]);
    await CoinsApiService.init();

    this.getCoinList();
    this.isInitialized = true;
  },
  watch: {
    searchQuery() {
      this.filterCoins();
    }
  },
  computed: {
    ...mapGetters(["currentUserPersonalInfo", "currentUser"]),
    name() {
      return this.$i18n.t("menu.coins");
    },
    displayData() {
      return this.searchQuery ? this.filteredData : this.dataSource;
    },
    headers() {
      return [
        {
          text: this.$i18n.t("commonTable.name"),
          align: "start",
          id: "name",
          sortable: false,
          width: "10%"
        },
        {
          text: "Rate",
          align: "start",
          id: "rate",
          sortable: false,
          width: "10%"
        },
        {
          text: "Gift Amount",
          align: "start",
          id: "giftAmount",
          sortable: false,
          width: "10%"
        },
        {
          text: "Size",
          align: "start",
          id: "bulkSize",
          sortable: false,
          width: "10%"
        },
        {
          text: "Price",
          align: "start",
          id: "bulkPrice",
          sortable: false,
          width: "10%"
        },
        {
          text: "Cashback",
          align: "start",
          id: "cashbackAmount",
          sortable: false,
          width: "10%"
        },
        {
          text: "Cashback Type",
          align: "start",
          id: "cashbackType",
          sortable: false,
          width: "10%"
        },
        // {
        //   text: "Discount (Min €/ $)",
        //   align: "start",
        //   id: "discounts",
        //   sortable: false,
        //   width: "10%"
        // },
        {
          text: "",
          align: "start",
          id: "actions",
          sortable: false,
          width: "3%"
        }
      ];
    }
  },
  methods: {
    async getCoinList() {
      await CoinsApiService.getAllCoins().then(response => {
        this.dataSource = response.data;
        this.filteredData = response.data;
        this.loading = false;
      });
    },
    filterCoins() {
      if (!this.searchQuery) {
        this.filteredData = this.dataSource;
        return;
      }

      const query = this.searchQuery.toLowerCase();
      this.filteredData = this.dataSource.filter(item => item.name.toLowerCase().includes(query));
    },
    toggleDiscounts(item) {
      // First, check if we're clicking on an already open item
      const isClosingCurrentItem =
        Object.prototype.hasOwnProperty.call(item, "showDiscounts") && item.showDiscounts;

      // Close all other open items
      this.dataSource.forEach(coin => {
        if (coin !== item && coin.showDiscounts) {
          this.$set(coin, "showDiscounts", false);
        }
      });

      // For the clicked item, toggle or set to true
      if (isClosingCurrentItem) {
        // If clicking on already open item, close it
        item.showDiscounts = false;
      } else {
        // Otherwise open this item
        this.$set(item, "showDiscounts", true);
      }
    },
    onCoinEdit(item) {
      this.$refs.coinDialog.open(item);
      this.$log.debug("Coin edit");
    },
    onCoinCreate() {
      this.$refs.coinDialog.open();
      this.$log.debug("Coin create");
    },
    onCoinDialogSave() {
      // Refresh the coin list after saving
      this.getCoinList();
    },
    async onCoinDelete(item) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to delete coin " + item?.name + " ?"
        )
      ) {
        this.deleteCoin(item);
      }
    },
    deleteCoin(item) {
      return CoinsApiService.deleteCoin(item?.id).then(() => {
        this.$bvToast.toast(this.$i18n.t("common.savedSuccessfully"), {
          title: this.$i18n.t("menu.coins"),
          solid: true,
          variant: "success",
          autoHideDelay: 1000
        });

        return true;
      });
    }
  }
};
